'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/date/secondsAgo.js